import { toneVariant, useCompanionNoun } from '@/utils/personalization'
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '💚',
    title: 'pages.onboarding.relationship.single',
    value: 'single',
  },
  {
    emoji: '💛',
    title: 'pages.onboarding.relationship.relationship',
    value: 'relationship',
  },
  {
    emoji: '💍',
    title: 'pages.onboarding.relationship.married',
    value: 'married',
  },
  {
    emoji: '💔',
    title: 'pages.onboarding.relationship.divorced',
    value: 'divorced',
  },
  {
    emoji: '🕊️',
    title: 'pages.onboarding.relationship.widowed',
    value: 'widowed',
  },
  {
    emoji: '🌀',
    title: 'pages.onboarding.relationship.complicated',
    value: 'complicated',
  },
]

export default function RelationshipQuestionPage() {
  const noun = useCompanionNoun()

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.relationship.title"
      subtitle={toneVariant('pages.onboarding.relationship.subtitle')}
      translationInterpolation={{ noun }}
    />
  )
}
